export default ".demo-jing-scroll {\n}"